import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import {
  showAppLoaderSelector,
  userIdSelector,
  isExternalIncompleteUserSelector
} from '../helpers/selectors';
import { popup_MobileAppSelector_SetVisibility } from '../actions/popup';

/**
 * Temporary gate on the web registration (/register/*) routes while registration
 * is being aligned with the mobile Keycloak flow.
 *
 * - A logged-in member (finishing an incomplete profile or adding a company
 *   profile) keeps access — for them the creation flow acts as "complete profile".
 * - A Keycloak-authenticated user still without a member (isExternalIncompleteUser)
 *   keeps access — that path is what the align work will build on.
 * - A fully anonymous visitor (classic web self-signup) is redirected home and
 *   shown the "use the mobile app" popup, since web self-signup is disabled.
 */
export default function RegisterAccessGuard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = useSelector(userIdSelector);
  const isExternalIncompleteUser = useSelector(isExternalIncompleteUserSelector);
  const showAppLoader = useSelector(showAppLoaderSelector);

  const allowed = Boolean(userId || isExternalIncompleteUser);

  useEffect(() => {
    // Wait for the Keycloak silent check-sso to settle before deciding the visitor
    // is anonymous, otherwise a hard refresh would block before the session loads.
    if (showAppLoader || allowed) return;

    dispatch(popup_MobileAppSelector_SetVisibility(true));
    navigate('/', { replace: true });
  }, [allowed, showAppLoader]);

  if (allowed) return <Outlet />;
  return null;
}
